import type { ReportEvent } from '@/models/reportEvent';
import type { TimelineEvent, TimelineEventKind } from '../types/historyEvent';
import { displayName } from './formatters';

const STATUS_TAG_NORMALIZE: Record<string, string> = {
  ADDENDED: 'ADDENDUM',
};

function normalizeTag(tag: string): string {
  return STATUS_TAG_NORMALIZE[tag] ?? tag;
}

export function mapReportEvents(events: ReportEvent[]): TimelineEvent[] {
  if (!events.length) return [];

  // API sends oldest-first; UI needs newest-first
  const reversed = [...events].reverse();

  return reversed.map((event, index) => ({
    id: event.uuid,
    kind: event.eventType as TimelineEventKind,
    timestamp: event.createdAt,
    actorName: displayName(event.actorFirstName, event.actorLastName),
    reportUuid: event.reportUuid,
    isCurrent: index === 0,
    statusTags: event.statusTags.map(normalizeTag),
  }));
}
